import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import Settings from "../../common/Settings";

const RecordTelefonos = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`numeros/list?cedula=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching telefonos records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching telefonos records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>
        <Card className="my-4" >
            <Card.Header className="display-4">{t("Teléfonos vinculados (Pasados y Actuales)")}</Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>{t("Teléfono")}</th>
                                <th>{t("Nombres")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records && records.map((item, index) => {
                                return (
                                    <tr key={index}>

                                        <td>{index + 1}.&nbsp;{item.telefono}</td>
                                        <td>{`${item.nombres || ""} ${item.apellido1 || ""} ${item.apellido2 || ""}`}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    </>
    );
};

export default RecordTelefonos;